import { gql } from '@apollo/client';

export const FETCH_FACILITY_WINDOWS_TIMEZONE = gql`
    query fetchFacilityWindowsTimezone($companyFilter: CompanyFilter!, $facilityFilter: FacilityFilter) {
        system {
            companies(filter: $companyFilter) {
                id
                facilities(filter: $facilityFilter) {
                    alias
                    windowsTimezone
                }
            }
        }
    }
`;
